class CheckboxCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.checked = options?.checked ? false
        @.color = options?.color ? false
        @.disabled = options?.disabled ? false
        @.error = options?.error ? false
        @.id = options?.id ? false
        @.label = options?.label ? 'Checkbox-Text'
        @.name = options?.name ? false
        @.outline = options?.outline ? false
        @.required = options?.required ? false
        @.value = options?.value ? false

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'label'
        @.$el.classList.add 'checkbox'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.color
            @.$el.classList.add "checkbox--#{@.color}"
        if @.error
            @.$el.classList.add 'checkbox--error'
        if @.outline
            @.$el.classList.add 'checkbox--outline'
        @.$el.innerHTML = "
            <input class='checkbox__input' type='checkbox' 
                #{ if @.checked then "checked" else "" } 
                #{ if @.disabled then "disabled" else "" } 
                #{ if @.required then "required" else "" }
            />
            <span class='checkbox__checkmark'></span>#{ @.label }
        "
        checkboxInput = @.$el.querySelector '.checkbox__input'
        if @.id
            checkboxInput.id = @.id
        if @.name
            checkboxInput.name = @.name
        if @.value
            checkboxInput.value = @.value
        return

window.CreateCheckbox = (options) ->
    return new CheckboxCreate options